import axios from 'axios';

// console.log(process.env.REACT_APP_PROXY);
// const proxy = process.env.REACT_APP_PROXY;

export const getUsoCFDIs = async () => {

    const url = process.env.REACT_APP_BASE_URL + "/api/UsoCFDI";

    var items = [];

    await axios.get(url)
    .then( response => {
        const data = response.data;
        items = data.map((item) => {
            return {
                value: item.clave,
                label: item.descripcion,
            };
        });
    })

    return items;
};


export const getRegimenFiscals = async () => {

    const url = process.env.REACT_APP_BASE_URL + "/api/RegimenFiscal";

    var items = [];

    await axios.get(url)
    .then( response => {
        const data = response.data;
        
        items = data.map((item) => {
            return {
                value: item.clave,
                label: item.descripcion,
            };
        });
    })
    
    return items;
};


export const getFormasPago = async () => {

    const url = process.env.REACT_APP_BASE_URL + "/api/FormaPago";

    var items = [];

    await axios.get(url)
    .then( response => {
        const data = response.data;
        
        items = data.map((item) => {
            return {
                value: item.clave,
                label: item.descripcion,
            };
        });
    })
    
    return items;
};


export const getPaises = async () => {

    const url = process.env.REACT_APP_BASE_URL + "/api/Pais";

    let items = [];

    await axios.get(url)
    .then( response => {
        const data = response.data;
        
        items = data.map((item) => {
            return {
                value: item.clave,
                label: item.descripcion,
            };
        });
    })

    return items;
}